import { z } from 'zod';

export const InheritanceProvisionRelationshipDataSchema = z.object({
  provisionNotes: z.string(),
});

export type ILegalTransactionRelationshipInheritanceProvisionData = z.infer<
  typeof InheritanceProvisionRelationshipDataSchema
>;

export function getEmptyInheritanceProvisionRelationshipData(): ILegalTransactionRelationshipInheritanceProvisionData {
  return {
    provisionNotes: '',
  };
}
